import { jsx as _jsx } from "react/jsx-runtime";
export const CheckCircleS = ({ color = 'currentColor', ...props })=>/*#__PURE__*/ _jsx("svg", {
        fill: "none",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12C2.25 6.61522 6.61522 2.25 12 2.25ZM12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75ZM15.4697 8.96973C15.7626 8.67683 16.2374 8.67683 16.5303 8.96973C16.8232 9.26262 16.8232 9.73738 16.5303 10.0303L11.0303 15.5303C10.7311 15.8294 10.25 15.8125 9.96973 15.5303L6.96973 12.5303C6.67578 12.2266 6.67055 11.7689 6.96973 11.4697C7.2689 11.1706 7.74609 11.1836 8.03027 11.4697L10.5 13.9395L15.4697 8.96973Z",
            fill: color
        })
    });

//# sourceMappingURL=check-circle-s.js.map